import { issueApi } from '@/api/issue';
import { useResidentStore } from '@/store';
import { message } from 'ant-design-vue';
import { isArray } from 'lodash';
import type {
  LocationQuery,
  NavigationGuardNext,
  RouteLocationNormalized,
} from 'vue-router';

export const setUrlByProjectCode = async (
  to: RouteLocationNormalized,
  next: NavigationGuardNext,
  queryName: string,
) => {
  const projectCode = to.query.projectCode;
  if (projectCode === undefined) {
    next();
    return;
  }
  const residentStore = useResidentStore();
  const projectCodes = isArray(projectCode) ? projectCode : [projectCode];
  const projectIds: string[] = [];
  for (const code of projectCodes) {
    const project = await residentStore.getSysProjectByCode(code);
    if (project) {
      projectIds.push(project.id.toString());
    } else {
      code !== undefined && message.warning(`不存在项目代号为<${code}>的项目`);
    }
  }
  const query: LocationQuery = { ...to.query };
  query[queryName] = projectIds;
  delete query.projectCode;
  next({
    name: to.name,
    query: query,
  });
};

export const setUrlByFWorkItemId = async (
  to: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const fWorkItemId = to.query.fWorkItemId;
  if (!fWorkItemId) {
    next();
    return;
  }
  const params = to.params;
  const query = {};
  const res = await issueApi.getIssueKeyByFWorkItemId(Number(fWorkItemId));
  if (res.code !== 0) {
    next(false);
    return;
  }
  params['issueKey'] = res.data;
  next({
    name: to.name,
    query,
    params,
  });
};
